import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "App";
import "fontsource-roboto/500.css";
import "./styles.css";
import * as serviceWorker from "./serviceWorker";

if (window.location.href.includes("mobily.com.sa")) {
  console.log = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div></div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
